import { Navigate, Outlet, useLocation } from "react-router-dom";

const useAuth = () => {
  const user = { loggedIn: false };
  const token = sessionStorage.getItem("authToken");
  if (token !== null) {
    const decodeUserDetails = JSON.parse(
      window.atob(sessionStorage.getItem("authToken").split(".")[1])
    );
    if (decodeUserDetails != null) {
      user.loggedIn = true;
    }
  }
  return user && user.loggedIn;
};

const getRole = () => {
  const token = sessionStorage.getItem("authToken");
  if (token !== null) {
    const decodeUserDetails = JSON.parse(
      window.atob(sessionStorage.getItem("authToken").split(".")[1])
    );
    if (decodeUserDetails != null)
      return decodeUserDetails["Role"];
    return null;
  }
};

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  const role = getRole();
  const location = useLocation();
  const path = location.pathname;
  if (isAuth) {
    if (role !== 'admin_role' && ((path === '/layout/shipments') || (path.includes('/layout/viewshipment')))) {
      return <Outlet />;
    }
    else if (role === 'admin_role') {
      return <Outlet />;
    }
    return <Navigate to="/" />;
  }
  return <Navigate to="/" />;
};

export default ProtectedRoutes;
